import { AddDigitalProduct } from 'autogen/swagger/all';
import track from 'modules/tracking/dataLayer';
import { addToCartTypeEventCategoryMapper, GA4Tracking } from 'modules/tracking/GA4';
import type { ProductActionProps } from '../../shared/types';

export default async function addDigitalProduct({ params, trackingInfo }: ProductActionProps['BuyNowDigitalProduct']) {
    const response = await AddDigitalProduct(params);

    const GA4TrackingObject = addToCartTypeEventCategoryMapper(trackingInfo.eventCategory);

    GA4TrackingObject.eventParams?.push({ param_name: 'is_digital_product', param_value: true });

    GA4Tracking(GA4TrackingObject);

    track(response.dataLayerDto);

    window.location.href = (response as any).redirectUrl;
}
